<template lang="pug">
    .banners.is-clearfix
        Banner.row(
            v-for="( banner, i ) in banners"
            :key="banner.id"
            :index="i"
            :banner="banner"
            :imageAlignment="imageAlignment"
        )
</template>

<script>

import _ from 'lodash'

import Banner from './Banner'

export default {
    name: 'Banners',
    props: {
        section: {
            type: Object,
            required: true,
        },
    },
    components: {
        Banner,
    },
    computed: {
        banners() {
            let banners = this.section.contents || []
            return _.cloneDeep(banners).sort((a, b) => _.get(a, 'position', 0) - _.get(b, 'position', 0))
        },
        imageAlignment() {
            if(this.section.settings != null){
                return _.find(this.section.settings, ['key', 'image_alignment']).value
            }else return 'left'
        }
    }
}
</script>

<style lang="sass" scoped></style>
